import request from '@/assets/js/utils/request'

export function getApps(data){
  return request({
    url: 'AppClient/Home/GetApps',
    method: 'post',
    data
  })
}



export function GetApps_new(data){
  return request({
    url: 'AppClient/Home/GetApps_new',
    method: 'post',
    data
  })
}


export function jsSdkConfig(data){
  return request({
    url: 'AppClient/Home/JsSdkConfig',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api/home.js